import { IInventoryPage } from '../../../inventory-page.interface';


export const UPLOAD_POD_STATISTICS_PAGE: IInventoryPage = {
	'route': '/upload/pod/statistics',
	'title': 'Statistics',
	'uiReference': [
		'Upload analytics',
		'Performance overview',
		'Review your tags, uploads, and design-library activity.',
		'Tags',
		'Uploads',
		'Designs',
		'Fetching Designs',
		'Analyzing...',
		'No Designs Found',
		'Tag summary',
		'Search tags',
		'Design library',
		'Total designs',
		'Tagged designs',
		'Ready to organize',
		'Without tags',
		'Review designs',
		'Tag usage',
		'Most used tags',
		'Compare tag frequency across your current design library.',
		'Tag inventory',
		'All tags',
		'unique tags',
		'No tags found',
		'Try a different search term.',
		'&lt; 0.01%',
		'Upload history range',
		'Platform activity',
		'Upload overview',
		'View performance',
		'uploads',
		'hours saved',
		'Time saved with Flying Upload',
		'hours',
		'Automated upload time — about day(s) or month(s) or year(s)',
		'Upload activity',
		'Upload history',
		'30 days',
		'90 days',
		'This month',
		'This year',
		'Last year',
		'All time',
		'All platforms',
		'History and proportions',
		'Combined yearly uploads and platform distribution.',
		'Yearly history',
		'Yearly uploads',
		'Platform proportions',
		'Platform history',
		'Uploads by platform',
		'Compare monthly activity for each connected marketplace.',
		'Design summary',
		'Created listings',
		'of designs',
		'MBA listings',
		'of listings',
		'MBA products',
		'Published product variants',
		'Library activity',
		'Design imports',
		'Imports into Design Management over time.',
		'Image insights',
		'Design assets',
		'Explore dimensions, file types, and dominant colors.',
		'Image sizes',
		'Image types',
		'Dominant colors',
		'Merch by Amazon',
		'Marketplaces',
		'Distribution of listings across marketplaces.',
		'Products',
		'Distribution across your published product types.',
		'Loading...',
		'( of )',
		'Remaining',
		'Stop',
		'Chart range'
	],
	'sources': [
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/pod-routing.module.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/statistics.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/statistics.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/statistics.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/tags-statistics-view/tags-statistics-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/tags-statistics-view/tags-statistics-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/uploads-statistics-view/uploads-statistics-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/uploads-statistics-view/uploads-statistics-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/designs-statistics-view/designs-statistics-view.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/designs-statistics-view/designs-statistics-view.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/progress-loader-card/progress-loader-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/progress-loader-card/progress-loader-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/inform-cards/info-card/info-card.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/shared/slider-chart/slider-chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/shared/slider-chart/slider-chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/uploads-statistics-view/yearly-upload-chart/yearly-upload-chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/uploads-statistics-view/yearly-upload-chart/yearly-upload-chart.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/uploads-statistics-view/yearly-upload-chart/yearly-upload-chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/shared/design-pie-chart/design-pie-chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/shared/design-pie-chart/design-pie-chart.data.ts',
		'apps/flying-projects/frontend/webapp/src/app/pages/upload/pod/statistics/sub-components/shared/design-pie-chart/design-pie-chart.component.html',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.ts',
		'apps/flying-projects/frontend/webapp/src/app/components/chart/chart.component.html'
	],
	'aliases': []
};
